import { homeAssetSrc } from 'components/landing/v3/homeAssetSrc';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

/** For CustomImage (relative path parsed by Next.js / speedsize loader). */
export function ringProUsAsset(file: string): string {
  return homeAssetSrc(`web_v2/ring-pro-us/v2/${file}`);
}

/** Full CDN URL for native <img> or <video poster>. */
export function ringProUsCdnAsset(file: string): string {
  return getCompressedAssetUrl(homeAssetSrc(`/web_v2/ring-pro-us/v2/${file}`));
}

